export default __webpack_public_path__ + "static/media/pacakgeModal3.49aa27f8.png";